import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"

const usePoiCollection = () => {
  const { locale } = useLocalization()

  const data = useStaticQuery(graphql`
    query AllCollectionPoisQuery {
      pois: allCollectionPois {
        nodes {
          title
          teaserExcerpt
          country
          city
          email
          phone
          state
          street
          zipCode
          latitude
          longitude
          url
          locale
        }
      }
    }
  `)

  /**
   * Get all POIs in the current locale
   */
  return React.useMemo(
    () => data.pois.nodes.filter(n => n.locale === locale),
    [data, locale]
  )
}

export default usePoiCollection
